import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 25px;  

    p {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color:  #484848;
        margin: 0;
    }
`;

export const Header = styled.h1`
  font-family: "Suisse International", sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #000000;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    gap: 16px;
`